import { useLayoutEffect, useRef, useState } from "react"

export default function MidiAssignMenu({
    isVisible,
    contextPosition,
    isMapping,
    toggleLabel,
    selectedDeviceId,
    midiInputs,
    onToggleMapping,
    onDeviceChange,
    onClearMapping,
    clearLabel = 'Quitar asignacion MIDI'
}) {
    const menuRef = useRef(null)
    const [safePosition, setSafePosition] = useState({ x: 0, y: 0 })

    useLayoutEffect(() => {
        if (!isVisible || !menuRef.current) return

        const { innerWidth, innerHeight } = window
        const menuRect = menuRef.current.getBoundingClientRect()
        const margin = 8

        const maxLeft = innerWidth - menuRect.width - margin
        const maxTop = innerHeight - menuRect.height - margin

        const nextX = Math.min(Math.max(contextPosition.x, margin), Math.max(maxLeft, margin))
        const nextY = Math.min(Math.max(contextPosition.y, margin), Math.max(maxTop, margin))

        if (nextX !== safePosition.x || nextY !== safePosition.y) {
            setSafePosition({ x: nextX, y: nextY })
        }
    }, [isVisible, contextPosition, safePosition.x, safePosition.y])

    if (!isVisible) return null

    return (
        <div
            ref={menuRef}
            className="fixed z-50 bg-neutral-900 border border-gray-700 rounded shadow-lg p-3 min-w-[240px]"
            style={{ top: safePosition.y, left: safePosition.x }}
        >
            <button
                type="button"
                className="w-full text-left px-2 py-1 mb-2 rounded bg-slate-800 hover:bg-slate-700"
                onClick={onToggleMapping}
            >
                {isMapping ? 'Detener mapeo MIDI' : toggleLabel}
            </button>
            <div className="space-y-2">
                <label className="block text-xs text-slate-400">Seleccionar dispositivo</label>
                <select
                    value={selectedDeviceId}
                    onChange={onDeviceChange}
                    className="w-full bg-slate-800 text-slate-100 px-2 py-1 rounded"
                >
                    <option value="">Todos</option>
                    {midiInputs.map((input) => (
                        <option key={input.id} value={input.id}>
                            {input.manufacturer ? `${input.manufacturer} - ` : ''}{input.name || input.id}
                        </option>
                    ))}
                </select>
            </div>
            {typeof onClearMapping === 'function' && (
                <button
                    type="button"
                    className="w-full text-left px-2 py-1 mt-2 rounded bg-slate-800 hover:bg-slate-700"
                    onClick={onClearMapping}
                >
                    {clearLabel}
                </button>
            )}
        </div>
    )
}
